/**
 * Payment order details — what /insured/order returns + the loading/error
 * status while fetching. Read by Review, Payment, BinderInvoice, and
 * CompleteOrder pages; many derived snapshot values key off it.
 */
class PaymentOrderStore {
  #listeners = new Set();

  #paymentOrderDetails = null;
  #paymentOrderLoading = false;
  #paymentOrderError = null;
  // Submission id the cached `paymentOrderDetails` belongs to. Lets
  // `refreshPaymentOrder(sid, { ifMissing: true })` short-circuit when
  // the order is already in the store for the requested sid — avoids the
  // duplicate fetch from Resume → LicenseScopePage mount.
  #loadedSubmissionId = null;

  get paymentOrderDetails() { return this.#paymentOrderDetails; }
  set paymentOrderDetails(v) { this.#paymentOrderDetails = v; this.#notify(); }

  get paymentOrderLoading() { return this.#paymentOrderLoading; }
  set paymentOrderLoading(v) { this.#paymentOrderLoading = !!v; this.#notify(); }

  get paymentOrderError() { return this.#paymentOrderError; }
  set paymentOrderError(v) { this.#paymentOrderError = v; this.#notify(); }

  get loadedSubmissionId() { return this.#loadedSubmissionId; }
  set loadedSubmissionId(v) { this.#loadedSubmissionId = v == null ? null : String(v); this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#paymentOrderDetails = null;
    this.#paymentOrderLoading = false;
    this.#paymentOrderError = null;
    this.#loadedSubmissionId = null;
    this.#notify();
  }
}

const paymentOrderStore = new PaymentOrderStore();
export default paymentOrderStore;
